import { render, staticRenderFns } from "./AmazonShopSyncMgmt.vue?vue&type=template&id=bf3c5230&scoped=true"
import script from "./AmazonShopSyncMgmt.vue?vue&type=script&lang=js"
export * from "./AmazonShopSyncMgmt.vue?vue&type=script&lang=js"
import style0 from "./AmazonShopSyncMgmt.vue?vue&type=style&index=0&id=bf3c5230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3c5230",
  null
  
)

export default component.exports